import { store } from '@/state/store';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { assert_string_uuid } from '@shared/asserts/utils_asserts_string';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { INVOCATION__base } from '@shared/dto/generation/graph_invoke/_invocations/_base/INVOCATION__base';

export function FN_GRAPH_NODE_try_select_existing_node(graph: DTO_GRAPH__instance) {
  const { g_graph__node_id_selected } = store.getState().slice_ui;

  const { nodes_map } = graph;
  if (nodes_map.has(g_graph__node_id_selected)) return; //already selected node from graph

  if (nodes_map.size() === 0) {
    UTILS__graph_ui.node__deselect();
    UTILS__graph_ui.edge__deselect();
    return;
  }

  let nodes = Array.from(nodes_map.values());
  nodes = nodes.sort(INVOCATION__base.sort_by_added_at).reverse();

  let node = nodes[0];

  assert_string_uuid(node.meta.node_id);

  UTILS__graph_ui.node__select(node.meta.node_id);
}
